import PropTypes from 'prop-types';
import React from 'react';
import { List } from 'immutable';

import RadioButton, { RadioButtonOption, RadioButtonField } from '@xanadu/ui-shared/components/widgets/RadioButton';

const Settings = ({
  oddsTypes,
  currencies,
  currency,
  oddsType,
  setOddsType,
  setCurrency,
}) => {
  const filteredOddsTypes = oddsTypes.filter(({ active }) => active);

  const onPropertyChange = (value, name) => {
    if (name === 'odds-type') {
      setOddsType(value);
    }

    if (name === 'currency') {
      setCurrency(value);
    }
  };

  return (
    <div style={{ marginTop: 16 }}>
      <RadioButtonField theme="dark" label="Odds Type">
        <RadioButton
          onChange={onPropertyChange}
          value={oddsType}
          fluid
        >
          {filteredOddsTypes.map(oddsTypeItem => (
            <RadioButtonOption
              key={oddsTypeItem.id}
              label={oddsTypeItem.name.toUpperCase()}
              value={oddsTypeItem.id}
              name="odds-type"
            />
          ))}
        </RadioButton>
      </RadioButtonField>
      <RadioButtonField label="Currency" theme="dark" >
        <RadioButton
          onChange={onPropertyChange}
          value={currency}
          fluid
        >
          {currencies.map(currencyItem => (
            <RadioButtonOption
              key={currencyItem.id}
              label={currencyItem.id}
              name="currency"
              value={currencyItem.id}
            />
          ))}
        </RadioButton>
      </RadioButtonField>
    </div>
  );
};

Settings.propTypes = {
  currencies: PropTypes.instanceOf(List).isRequired,
  oddsTypes: PropTypes.instanceOf(List).isRequired,
  currency: PropTypes.string.isRequired,
  oddsType: PropTypes.string.isRequired,
  setCurrency: PropTypes.func.isRequired,
  setOddsType: PropTypes.func.isRequired,
};

export default Settings;
